import { createSlice } from '@reduxjs/toolkit';
import { Slices } from 'ducks/slices';

export type StandardOutState = string;

const initialState: StandardOutState = '';

const standardOutSlice = createSlice({
  name: Slices.STANDARD_OUT,
  initialState,
  reducers: {
    setStandardOut: (_, action) => {
      return action.payload;
    },
    updateStandardOut: (state, action) => {
      return state.concat(action.payload);
    },
    clearStandardOut: () => {
      return initialState;
    },
  },
});

export const { setStandardOut, updateStandardOut, clearStandardOut } = standardOutSlice.actions;

export default standardOutSlice.reducer;
